export default __webpack_public_path__ + "static/media/Frog.6d4638a6.jpg";